import React from "react";
import { useTwoStepAuthCode } from "@/features/two-step-authentication/hooks/use-two-step-authentication-code";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { useTwoStepAuthCodeStates } from "@/features/two-step-authentication/hooks/use-two-step-authentication-code-states";
import { SegmentedForm } from "@/shared/components/text-box/segmented-form";
import { useLoginContext } from "@/features/auth/contexts/login-context";

interface CodeProps {
  onCloseModal: () => void;
  onCompleteModal: () => void;
  setIsValid: React.Dispatch<React.SetStateAction<boolean>>;
}

// 2段階認証コード入力モーダル
export const TwoStepAuthSetCodeModal = ({ onCloseModal, onCompleteModal, setIsValid }: CodeProps) => {
  const {
    email,
    setTwoStepSetCode,
  } = useLoginContext();
  const {
    verifySetCode,
  } = useTwoStepAuthCode({ onCompleteModal });
  const {
    isActiveSetCodeVerifyButton,
    setIsActiveSetCodeVerifyButton,
  } = useTwoStepAuthCodeStates();

  return (
    <BasePageModal
      title="2段階認証の設定"
      handleClose={onCloseModal}
      className="md-user-2factor-mail"
      disableOverlayClose={true}
      bottomChildren={
        <BaseRoundButton
          id="btnSubmit"
          buttonText="登録"
          onClick={() => {
            verifySetCode();
            setIsValid(true);
          }}
          isActive={isActiveSetCodeVerifyButton}
        />
      }
    >
      <h2>認証コードを入力してください</h2>
      <dl>
        <dt>認証コード</dt>
        <dd className="input_code">
          <SegmentedForm
            onChange={(value, isComplete) => {
              setTwoStepSetCode(value);
              setIsActiveSetCodeVerifyButton(isComplete)
            }}
            id={"code"}
            length={6}
          />
        </dd>
      </dl>
      <div className="message">
        <p>利用者ID({email})宛に認証コードを送信しました。</p>
        <p>受信したメールに記載されている認証コードを入力してください。</p>
        <p>メールサーバー上で自動的に、&quot;迷惑メール&quot;などの通常使用しているフォルダ以外に送信される場合がありますのでご注意ください。</p>
        <p>ドメイン指定などの受信設定の影響で届かない場合がありますので、「@mail.sorimachi.co.jp」のドメインを受信できるよう設定ください。</p>
      </div>
    </BasePageModal>
  );
};
